import type { PropsWithChildren } from "react";
import { memo } from "react";

import type { IContentLabelProps } from "./types";

import { Label } from "@/components/atoms/label";
import { Typography } from "@/components/atoms/typography";
import { Icon } from "@/components/atoms/icon";

export const ContentLabel = memo(function ContentLabel(
  props: PropsWithChildren<IContentLabelProps>,
) {
  const {
    text,
    iconName,
    children,
    labelSize,
    isRequired,
    description,
    htmlFor,
    noRequiredOrOptional,
  } = props;

  return (
    <>
      <div className={"d-flex-column gap-4"}>
        <div className={"d-flex gap-8"}>
          {iconName && (
            <div className={"icon-wrapper"}>
              <Icon
                fontSize={"fs-20"}
                name={"CustomerService2Fill"}
                color={"icon-strong-950"}
              />
            </div>
          )}
          <Label
            text={text}
            htmlFor={htmlFor}
            labelSize={labelSize}
            isRequired={isRequired}
            noRequiredOrOptional={noRequiredOrOptional}
          />
        </div>
        <Typography fontType={"paragraph-x-small"} themeColor={"text-sub-600"}>
          {description}
        </Typography>
      </div>
      <div>{children}</div>
    </>
  );
});
ContentLabel.displayName = "ContentLabel";
